import React from 'react';
import styled from 'styled-components';
import { getColor } from 'common/constants/_colors';
import { Flex } from './base/layout-components';
import Text from './base/Text';
import BoldedValue from './BoldedValue';
const Total = styled(BoldedValue)`
  ${({ extraInfo }) =>
    extraInfo
      ? `border-right: 1px solid ${getColor('botticelli')};
    padding-right: 1rem;
    margin-right: 1rem;`
      : ''}
`;
const Icon = styled.img`
  width: 2.2rem;
  margin-right: 1.2rem;
`;
const IconedValueLine = ({ icon, value, descriptor, extraInfo, ...rest }) => {
  return (
    <Flex align='center' {...rest}>
      <Icon src={icon} alt='' />
      <Flex items='baseline'>
        <Total
          extraInfo={extraInfo}
          value={{ size: 'x-x-large', text: value }}
          description={{ size: 'small', text: descriptor }}
        />
        {extraInfo && (
          <Text color='shuttleGray' size='small'>
            {extraInfo}
          </Text>
        )}
      </Flex>
    </Flex>
  );
};

export default IconedValueLine;
